<template>
    <div class="topcode-wechat-device-item" @click="$router.push('/device/detail/' + device.id)">
        <div class="top">
            <div :class="'flex-center-y auto-width-8 state  device-state-'+device.deviceState">{{deviceStateDICT}}</div>
            <div class="flex-center-y time ">{{device.heartBeatTime}}</div>
        </div>
        <div class="body">
            <div class="left">
                <div class="flex-center-y center">
                    <img :src="downloadImg + device.productImage1"/>
                    <div class="name" style="font-size: 14px">
                        <div class="title-small">{{device.name}}</div>
                        <div>{{device.productName}}</div>
                    </div>
                </div>
            </div>
            <div class="flex-center right">
                详情<van-icon name="arrow"/>
            </div>
        </div>
        <div class="footer">
            <div class="footer-left">
                <div class="row" style="font-size: 14px"><label>设备编号</label> <span>{{device.sn}}</span></div>
                <div class="row" style="font-size: 14px"><label>所属单位</label> <span>{{device.unitName}}</span></div>
                <div class="row" style="font-size: 14px"><label>归属分组</label> <span>{{device.unitGroupName}}</span></div>
                <div class="row" style="font-size: 14px"><label>所属区域</label> <span>{{device.areaName}}</span></div>
                <div class="row" style="font-size: 14px"><label>安装位置</label> <span>{{device.installLocation}}</span>
                </div>
            </div>
            <div class="footer-right" v-if="device.coreStateList.length!==0">
                <div class="right-state-view" v-for="item in device.coreStateList" :key="item.id">
                    <span class="right-state" v-if="item.value!==null">{{item.value}}</span>
                    <span class="right-state" v-else>-</span>
                </div>
            </div>
            <div class="footer-right-empty" v-else>
            </div>
        </div>
    </div>
</template>

<script>
    import UploadImage from "@/components/UploadImage";
    import {Tag} from "vant";
    import * as DICT from "@/utils/dict"
    import {downloadImg} from "@/config"

    export default {
        components: {
            UploadImage,
            Tag
        },
        props: {
            device: {type: Object, required: true}
        },
        data() {
            return {
                downloadImg
            };
        },
        computed: {
            deviceStateDICT() {
                return DICT.getValue('DEVICE_STATE_TYPE', this.device.deviceState)
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-device-item {
        width: 100%;
        /*height: 225px;*/
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        /*background: #51c332;*/

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                justify-content: center;
                /*width: 60px;*/
                border-radius: 8px 0px 0px 0px;
            }
            & > .time {
                height: 100%;
                width: 100%;
                padding-right: 5px;
                justify-content: flex-end;

            }
        }
        & > .body {
            display: flex;
            & > .left {
                padding: 8px;
                width: 100%;
                & > .center {
                    /*padding: 5px;*/
                    display: flex;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 60px;
                        height: 60px;
                        background: #cccccc;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        /*background: #7e7e7e;*/
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
            }
            & > .right {
                width: 75px;
                color: #fa7d2d;
                font-size: 14px;
                font-weight: 500;
            }
        }
        & >.footer{
            display: flex;
            padding: 0 8px 0 15px;

            & > .footer-left{
                width: 1px;
                display: flex;
                flex-grow: 1;
                flex-direction: column;

                    & > .row {
                    display: flex;
                    line-height: 1.5;
                    /*align-items: center;*/
                    & > label {
                        width: 75px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                   
                }
            }
            & > .footer-right{
                width: 60px;
                display: flex;
                height: 105px;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                & > .right-state-view{
                    width: 40px;
                    height: 40px;

                    & > .right-state{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background-color: #23b1f8;
                        border-radius: 8px;
                        color: #fff;
                    }
                }
            }
            & > .footer-right-empty{
                width: 0;
                display: flex;
                height: 105px;
            }
        }
    }
</style>
